/* eslint-disable */
import { useEffect, useState } from "react";
import { Modal } from 'react-bootstrap';
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch } from "react-redux";
import { addDebarUser } from "../actions/debarManagementActions";
import labels from '../labels/debar_users_en.json';
// import "../../styles/admin_user_nav.css"
import { useForm } from "react-hook-form";
import DateCustom from "../../../common/components/Date";
import commonLabels from '../../../common/labels/common_en.json';


const AddDebarUser = (props) => {
    const { register, handleSubmit, formState, errors, watch, control } = useForm({
        mode: "onChange",
    });
    const [dob, setDob] = useState('');
    const [debarOn, setDebarOn] = useState('');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [isPermannentVal, setIsPermannentVal] = useState(false);
    const dispatch = useDispatch();
    const onSubmit = (data) => {
        if (data) {
            const requestData = {
                "candidateName": data.candidateName,
                "fatherHusbandName": data.fatherHusbandName,
                "motherName": data.motherName,
                "aadhaarNo": data.aadhaarNo,
                "mobileNo": data.mobileNo,
                "emailId": data.emailId,
                "dob": dob,
                "pscName": data.pscName,
                "letterNo": data.letterNo,
                "debarOn": debarOn,
                "reason": data.reason,
                "isPermanent": data.isPermanent === "true" ? true : false,
                "dateFrom": dateFrom,
                "dateTo": dateTo,
            }
            dispatch(addDebarUser(requestData, props.setAddDebarModal))
        }
    }

useEffect(()=>{
    setIsPermannentVal(watch("isPermanent"))
},[watch("isPermanent")])

    return (
        <form >
            <Modal size="xl" show={props.addDebarModal} onHide={() => { props.setAddDebarModal(false) }} aria-labelledby="example-modal-sizes-title-xl" backdrop='static'>
                <Modal.Header  className="logout_heading">
                    <Modal.Title  className="logout_title">
                        Add Debar User
                    </Modal.Title>
                      <button
                        type="button"
                        className="ms-auto logout_close"
                        aria-label="Close"
                       onClick={() => { props.setAddDebarModal(false) }}
                    >X</button>
                </Modal.Header>
                <Modal.Body>
                    <div className="row" >
                        <div className="form-group col-md-6 mb-0">
                            <label className="LeftText">{labels.CANDIDATE_NAME} <span className="redColor">*</span></label>
                            <input
                                className="input bg-color"
                                name="candidateName"
                                ref={register({
                                    required: true,
                                })}
                            />
                        </div>
                        <div className="form-group col-md-6 mb-0">
                            <label className="LeftText">{labels.FATHER_HUSBAND_NAME} <span className="redColor">*</span></label>
                            <input
                                className="input bg-color"
                                name="fatherHusbandName"
                                ref={register({
                                    required: true,
                                })}
                            />
                        </div>
                        <div className="form-group col-md-6 mb-0">
                            <label className="LeftText">{labels.MOTHER_NO} <span className="redColor">*</span></label>
                            <input
                                className="input bg-color"
                                name="motherName"
                                ref={register({
                                    required: true,
                                })}
                            />
                        </div>
                        <div className="form-group col-md-6 mb-0">
                            <label className="LeftText">{labels.AADHAAR_NO} <span className="redColor">*</span></label>
                            <input
                                className="input bg-color"
                                name="aadhaarNo"
                                maxLength={12}
                                ref={register({
                                    required: true,
                                })}
                            />
                        </div>
                        <div className="form-group col-md-6 mb-0">
                            <label className="LeftText">{labels.MOBILE_NO} <span className="redColor">*</span></label>
                            <input
                                className="input bg-color"
                                name="mobileNo"
                                maxLength={10}
                                ref={register({
                                    required: true,
                                })}
                            />
                        </div>
                        <div className="form-group col-md-6 mb-0">
                            <label className="LeftText">{labels.EMAIL_ID} <span className="redColor">*</span></label>
                            <input
                                className="input bg-color"
                                name="emailId"
                                ref={register({
                                    required: true,
                                })}
                            />
                        </div>
                        <div className="form-group col-md-6 mb-0">
                            <label className="LeftText">{labels.DOB} <span className="redColor">*</span></label>
                            <DateCustom
                                name={"dob"}
                                dateState={dob}
                                setDateState={setDob}
                                placeholderText={commonLabels.COMMON.DATE_FORMAT}
                                dateFormat={commonLabels.COMMON.SMALL_SIZE_DATE_FORMAT}
                            />
                        </div>
                        <div className="form-group col-md-6 mb-0">
                            <label className="LeftText">{labels.PSC_NAME} <span className="redColor">*</span></label>
                            <input
                                className="input bg-color"
                                name="pscName"
                                ref={register({
                                    required: true,
                                })}
                            />
                        </div>
                        <div className="form-group col-md-6 mb-0">
                            <label className="LeftText">{labels.LETTER_NO} <span className="redColor">*</span></label>
                            <input
                                className="input bg-color"
                                name="letterNo"
                                ref={register({
                                    required: true,
                                })}
                            />
                        </div>
                        <div className="form-group col-md-6 mb-0">
                            <label className="LeftText">{labels.DEBAR_ON} <span className="redColor">*</span></label>
                            <DateCustom
                                name={"debarOn"}
                                dateState={debarOn}
                                setDateState={setDebarOn}
                                placeholderText={commonLabels.COMMON.DATE_FORMAT}
                                dateFormat={commonLabels.COMMON.SMALL_SIZE_DATE_FORMAT}
                            />
                        </div>
                        <div className="form-group col-md-6 mb-0">
                            <label className="LeftText">{labels.REASON} <span className="redColor">*</span></label>
                            <input
                                className="input bg-color"
                                name="reason"
                                ref={register({
                                    required: true,
                                })}
                            />
                        </div>
                        <div className="form-group col-md-6 mb-0">
                            <label className="LeftText">{labels.IS_PERMANENT} <span className="redColor">*</span></label>
                            <select
                                className="form-control"
                                name="isPermanent"
                                ref={register({ required: true })}
                            >
                                <option value="">Select</option>
                                <option value={true}>Yes</option>
                                <option value={false}>No</option>
                            </select>
                        </div>
                        <div className="form-group col-md-6 mb-0">
                            <label className="LeftText">{labels.DATE_FROM} <span className="redColor">  {isPermannentVal == "false" && "*"}  </span></label>
                            <DateCustom
                                name={"dateFrom"}
                                dateState={dateFrom}
                                setDateState={setDateFrom}
                                placeholderText={commonLabels.COMMON.DATE_FORMAT}
                                dateFormat={commonLabels.COMMON.SMALL_SIZE_DATE_FORMAT}
                            />
                        </div>
                        <div className="form-group col-md-6 mb-0">
                            <label className="LeftText">{labels.DATE_TO} <span className="redColor">  {isPermannentVal == "false" && "*"}  </span></label>
                            <DateCustom
                                name={"dateTo"}
                                dateState={dateTo}
                                setDateState={setDateTo}
                                placeholderText={commonLabels.COMMON.DATE_FORMAT}
                                dateFormat={commonLabels.COMMON.SMALL_SIZE_DATE_FORMAT}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" type="button" onClick={() => { props.setAddDebarModal(false) }}>Cancel</button>
                    <button className=" btn btn-primary custom_button   " type="submit" onClick={handleSubmit((e) => { onSubmit(e) })}>Save</button>
                </Modal.Footer>
            </Modal>
        </form>

    )
}

export default AddDebarUser;